class ProductFilterController extends AbstractEntityEditController
	@register()
	@inject '$filter',
		'productFilter'
		'ProductFilterRepository'

	initialize: ->
		@mainCrud.entityType = 'general.product_filter'
		@mainCrud.isNewEntity = !@productFilter.id?

		if !@mainCrud.isNewEntity
			@mainCrud.entityTitle = @productFilter.name
		else
			@mainCrud.entityTitle = 'general.product_filter.new'

	save: ->
		@mainCrud.saving = true

		@ProductFilterRepository
			.save @productFilter, @mainCrud.isNewEntity
			.then (response) =>
				@productFilter = response.data
				@afterSave response
			.catch (result) =>
				@handleErrors result
			.finally =>
				@mainCrud.saving = false

	delete: ->
		@deleteEntity @ProductFilterRepository, @productFilter
